import React, { Component } from "react";
import { Link } from "react-router-dom";
import cookies from "js-cookie";

class Navbar extends Component {
  state = {
    token: "",
  };
  componentDidMount() {
    const token = cookies.get("token");
    const newState = this.state;
    newState.token = token;
    this.setState(newState);
  }
  render() {
    return (
      <header
        style={
          this.props.style
            ? { borderRadius: "0 0 50px 0 " }
            : { borderRadius: "0px", height: "100px" }
        }
      >
        <h1>
          <Link to="/Home">KoalaSurvey</Link>
        </h1>
        <nav>
          <div>
            <Link to="/Pricing">Pricing</Link>
            <Link to="/About">About</Link>
            {this.state.token ? (
              <Link to="/Profile">Profile</Link>
            ) : (
              <>
                <Link to="/Login">Login</Link>
                <Link to="Register" className="primary">
                  Register
                </Link>
              </>
            )}
          </div>
        </nav>
      </header>
    );
  }
}

export default Navbar;
